import React from "react";
import classNames from "classnames";
import Swipe from "react-easy-swipe";
import Chat from "./Chat";
import ChatButton from "./ChatButton/ChatButton";
import Icon from "../Icon/Icon";
import closeIcon from "icons/close.svg";
import ReactDOM from "react-dom";


export default class SwipeableChat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }
  
  toggleChat = () => {
    this.setState({
      isOpen: !this.state.isOpen,
      isFull: false
    });
  };
  
  onSwipeUp = () => {
    this.setState({
      isFull: true
    })
  };
  
  render() {
    const { isFull, isOpen } = this.state;
    const chatClasses = classNames(
      "swipeable-chat",
      { "is-open": isOpen },
      { "is-full": isFull }
    );
    
    return (
      <React.Fragment>
        <Swipe className={chatClasses} onSwipeUp={ this.onSwipeUp }>
          <div onClick={ this.toggleChat } className="swipeable-chat__close">
            <Icon glyph={ closeIcon }/>
          </div>
          <Chat/>
        </Swipe>
        {ReactDOM.createPortal(
          <ChatButton onClick={ this.toggleChat } hidden={ this.state.isOpen }/>,
          document.body
        )}
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./app/components/Chat/SwipeableChat.jsx